import qs from 'qs'
import React, { useState, useEffect, useCallback, useContext } from "react"
import StatusIconText from "../../components/StatusIconText"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { LoadingPage } from "../AuxiliarPages/LoadingPage/LoadingPage"
import { ErrorPage } from "../AuxiliarPages/ErrorPage/ErrorPage"
import { NoAccessPage } from "../AuxiliarPages/NoAccessPage/NoAccessPage"
import { Pagination } from "../../components/Pagination"
import { DatetimeBlock } from "../../components/DatetimeBlock"
import { DataField } from "../../components/DataField"
import { FilterGroup } from "./FilterGroup/FilterGroup"
import { formatDateToISOZulu } from "../../utils/utils"
import AuthContext from "../../context/auth-context"
import { frontEnvelopeFolderStatusToBack } from "../../utils/utils"
import ErrorBoundary from '../AuxiliarPages/ErrorBoundary/ErrorBoundary'

export const EnvelopeFolderInbox = (props) => {

    const userRoles = useContext(AuthContext).user_data.roles
    const navigate = useNavigate()

    const [fetchedData, setFetchedData] = useState(undefined)
    const [error, setError] = useState({
        hasError: false,
        statusCode: 200
    })
    const [loading, setLoading] = useState(true)
    const [filterLoading, setFilterLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(0)
    const [maxPage, setMaxPage] = useState(0)
    const initialFilterState = {
        external_id: "",
        status: "",
        initial_date: "",
        final_date: "",
        subject: "",
        document_number: ""
    }
    const [filters, setFilters] = useState(initialFilterState)
    const [config, setConfig] = useState({
        params: {
            page_number: 0,
            page_rows: 7
        }
    })

    const requestEnvelopeFolders = useCallback(() => {
        setLoading(true)
        const timer = setTimeout(() => {
            setFilterLoading(true)
            const queryString = qs.stringify(config, { arrayFormat: 'repeat', encode: false }).replaceAll("params", "").replaceAll("[", "").replaceAll("]", "")
            axios.get(`/dash/sign/envelope_folders?${queryString}`)
                .then((response) => {
                    setFetchedData(response.data)
                    setMaxPage(response.data.pagination.number_of_pages)
                })
                .catch((error) => {
                    if ([404].includes((error.response || {}).status)) {
                        setError({
                            "hasError": true,
                            "statusCode": error.response.status
                        })
                    } else {
                        setError({
                            "hasError": true,
                            "statusCode": 500
                        })
                    }
                })
                .finally(() => {
                    setLoading(false)
                    setFilterLoading(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }, [config])

    useEffect(() => {
        let newConfig
        newConfig = config
        newConfig.params.page_number = currentPage
        setConfig(newConfig)
        requestEnvelopeFolders()
    }, [currentPage, config, requestEnvelopeFolders])

    const onFilter = useCallback(() => {
        setCurrentPage(0)
        let newConfig = {
            params: {
                page_number: 0,
                page_rows: 7
            }
        }
        Object.keys(filters).forEach((filter_key) => {
            if (filters[filter_key]) {
                if (filter_key === "document_number") {
                    newConfig.params[filter_key] = filters[filter_key].replaceAll(".", "").replaceAll("-", "").replaceAll(" ", "")
                } else if (filter_key === "subject") {
                    newConfig.params[filter_key] = filters[filter_key].replaceAll(" ", "_").replaceAll(" ", "").toLowerCase()
                } else if (filter_key.includes("date")) {
                    newConfig.params[filter_key] = formatDateToISOZulu(filters[filter_key], filter_key)
                } else if (filter_key === "status") {
                    newConfig.params[filter_key] = frontEnvelopeFolderStatusToBack[filters[filter_key]].backStatus
                } else {
                    newConfig.params[filter_key] = filters[filter_key]
                }
            }
        })
        setConfig(newConfig)
    }, [filters])

    if (!userRoles.includes("list_envelope_folders")) {
        return (
            <NoAccessPage />
        )
    }
    if (loading) {
        return (
            <div className="page-container">
                <FilterGroup filters={filters} setFilters={setFilters} onFilter={onFilter} filterLoading={filterLoading} />
                <header>
                    <h1>
                        Listagem de Pastas de Envelopes
                    </h1>
                </header>
                <LoadingPage />
            </div>
        )
    } else if (error.hasError) {
        return (
            <ErrorPage />
        )
    } else if (fetchedData) {
        return (
            <div className="page-container">
                <FilterGroup filters={filters} setFilters={setFilters} onFilter={onFilter} filterLoading={filterLoading} />
                <header>
                    <h1>
                        Listagem de Pastas de Envelopes
                    </h1>
                </header>
                {fetchedData.envelope_folders.length === 0 &&
                    <p className="message__container message__container--centered">
                        <span className="message__text">
                            Nenhuma pasta de envelopes
                        </span>
                    </p>}
                <ul className="inbox">
                    {fetchedData.envelope_folders.length !== 0 &&
                        <li className="inbox__header">
                            <div className="inbox__cell--left">Criado em:</div>
                            <div className="inbox__cell--center">Envelopes:</div>
                            <div className="inbox__cell--right">Status:</div>
                        </li>}
                    {fetchedData.envelope_folders.map((envelopeFolder) => (
                        <li key={envelopeFolder.envelope_folder_key} className="inbox__body">
                            <ErrorBoundary>
                                <div className="inbox__cell--left inbox__cell--row-container">
                                    <DatetimeBlock dateString={envelopeFolder.created_at} />
                                    <div>
                                        <DataField
                                            label="Nome da Pasta"
                                            field={envelopeFolder.subject}
                                        />
                                        <DataField
                                            label="ID da Pasta"
                                            field={envelopeFolder.id}
                                        />
                                    </div>
                                </div>
                                <div className="inbox__cell--center">
                                    {(envelopeFolder.envelopes || []).map((envelope) => (
                                        <p
                                            className="inbox__cell--normal-text"
                                            key={envelope.envelope_key}
                                        >
                                            {envelope.subject}
                                        </p>
                                    ))}
                                </div>
                                <div className="inbox__cell--right inbox__cell--row-container">
                                    <StatusIconText
                                        id={envelopeFolder.envelope_folder_key}
                                        status={envelopeFolder.status}
                                        type="envelope_folder_status"
                                    />
                                    {
                                        userRoles.includes("read_envelope_folder") &&
                                        <a
                                            href={`/folder/${envelopeFolder.envelope_folder_key}`}
                                            className="btn btn--animated btn--white"
                                            onClick={(e) => {
                                                if (
                                                    e.ctrlKey ||
                                                    e.metaKey ||
                                                    e.button === 1
                                                ) {
                                                    return;
                                                }
                                                e.preventDefault();
                                                navigate(`/folder/${envelopeFolder.envelope_folder_key}`);
                                            }}
                                        >
                                            <ArrowRightIcon
                                                style={{ scale: "1.2", height: "1.5rem", width: "1.8rem" }}
                                            />
                                        </a>
                                    }
                                </div>
                            </ErrorBoundary>
                        </li>
                    ))}
                </ul>
                <ErrorBoundary>
                    <Pagination
                        currentPage={currentPage}
                        maxPage={maxPage}
                        setCurrentPage={setCurrentPage}
                        maxVisiblePages={7}
                    />
                </ErrorBoundary>
            </div>
        )
    }
}
